
import { Component, Mixins } from "vue-property-decorator";
import { ITextJoinBehavior } from "../../../../../../documaker/domain/format/objects";
import { ITextJoinBehaviorPropertyEditable, instanceOfITextJoinBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TextJoinBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITextJoinBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITextJoinBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTextJoinBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITextJoinBehaviorPropertyEditable(s) && s.textJoinBehavior().isEditable(), false);
  }

  get textJoinBehavior(): ITextJoinBehavior {
    return this.readPropertyOrDefault(s => s.textJoinBehavior().getValue(), { shouldJoinWithNewLine: false, items: [] });
  }

  set textJoinBehavior(value: ITextJoinBehavior) {
    this.writePropertyWhenValid(s => s.textJoinBehavior().setValue(value));
  }
}
